import { render, staticRenderFns } from "./AuditSiteExclusionRegexForm.vue?vue&type=template&id=561bb514&scoped=true&"
import script from "./AuditSiteExclusionRegexForm.vue?vue&type=script&lang=js&"
export * from "./AuditSiteExclusionRegexForm.vue?vue&type=script&lang=js&"
import style0 from "./AuditSiteExclusionRegexForm.vue?vue&type=style&index=0&id=561bb514&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561bb514",
  null
  
)

export default component.exports